var map = {
	"./brush.webp": 706,
	"./checkbox-off.webp": 721,
	"./checkbox-on.webp": 17,
	"./clear.webp": 455,
	"./close.webp": 262,
	"./copy.webp": 965,
	"./copyright.webp": 783,
	"./delete-all.webp": 236,
	"./delete.webp": 551,
	"./down.webp": 238,
	"./download.webp": 819,
	"./export.webp": 389,
	"./fill.webp": 258,
	"./flood.webp": 853,
	"./import.webp": 369,
	"./info.webp": 949,
	"./invert.webp": 915,
	"./left.webp": 972,
	"./line.webp": 57,
	"./new.webp": 403,
	"./redo.webp": 365,
	"./reflect-x.webp": 140,
	"./reflect-y.webp": 789,
	"./right.webp": 11,
	"./rotate-neg.webp": 754,
	"./rotate-pos.webp": 214,
	"./settings.webp": 34,
	"./undo.webp": 20,
	"./up.webp": 598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 938;